import type { FacilitiesData } from "@/data/types";
import facilitiesDataJson from "@/data/facilities.json";

export function useFacilitiesData() {
  const facilitiesData = facilitiesDataJson as FacilitiesData;
  return { facilitiesData, loading: false, error: null };
}